import { WebApiRequest, HTTP_GET, HTTP_POST, HTTP_DELETE } from "tools/webservice";
import { Ref } from "react";
import { EmployeeCustomerSurveyTypeDto, NameNumberDto, QueueTypeEnum, EmployeeCustomerSurveyTypeMapDto, EmployeeClockedIn, EmployeeCustomerSurveyTypeGetResponse, GetUsersByAccountSurveyTypeResponse } from "interfaces/Mueller.Business.Models";

export const getMappings = (employeeId: number, successCallback: (mappings: EmployeeCustomerSurveyTypeGetResponse[]) => void, errorCallBack: () => void, mountedRef: Ref<Boolean>) => WebApiRequest({
  method: HTTP_GET,
  endpoint: `/employee-mappings/employee/${employeeId}`,
  successCallback: successCallback,
  errorCallback: errorCallBack,
  mountedRef: mountedRef
});

export const addMapping = (employeeId: number, payload: EmployeeCustomerSurveyTypeDto[], successCallback: () => void, errorCallBack: () => void, mountedRef: Ref<Boolean>) => WebApiRequest({
  method: HTTP_POST,
  payload,
  endpoint: `/employee-mappings/employee/${employeeId}`,
  successCallback: successCallback,
  errorCallback: errorCallBack,
  mountedRef: mountedRef
});

export const removeMapping = (employeeId: number, payload: number[], successCallback: (() => void) | ((value: any) => void), errorCallBack: (response: any) => void, mountedRef: Ref<Boolean>) => WebApiRequest({
  method: HTTP_DELETE,
  payload,
  endpoint: `/employee-mappings/employee/${employeeId}`,
  successCallback: successCallback,
  errorCallback: errorCallBack,
  mountedRef: mountedRef
});

export const getCustomerExperienceDirector = (customerNumber: number, successCallback: (director: NameNumberDto) => void, mountedRef: Ref<Boolean>) => WebApiRequest({
  method: HTTP_GET,
  endpoint: `/employee-mappings/customers/${customerNumber}`,
  successCallback: successCallback,
  mountedRef: mountedRef
});

export const getCustomerExperienceManager = (customerNumber: number, surveyTypeCode: string, successCallback: (manager: NameNumberDto) => void, mountedRef: Ref<Boolean>) => WebApiRequest({
  method: HTTP_GET,
  endpoint: `/employee-mappings/customers/${customerNumber}/survey-types/${surveyTypeCode}`,
  successCallback: successCallback,
  mountedRef: mountedRef
});

export const getAccountListByQueueType = (queueType: string | QueueTypeEnum, employeeId: number, successCallback: (response: EmployeeCustomerSurveyTypeMapDto[]) => void, errorCallback: () => void, mountedRef: Ref<Boolean>) => WebApiRequest({
  method: HTTP_GET,
  endpoint: `/employee-mappings/queue-type/${queueType}/customers/survey-types/employee-filter/${employeeId}`,
  successCallback,
  errorCallback,
  mountedRef,
});

export const getUsersByAccountSurveyType = (queueType: string | QueueTypeEnum, customerId: number, surveyTypeId: number, successCallback: (response: GetUsersByAccountSurveyTypeResponse) => void, errorCallback: () => void, mountedRef: Ref<Boolean>) => WebApiRequest({
  method: HTTP_GET,
  endpoint: `/employee-mappings/queue-type/${queueType}/customers/${customerId}/survey-types/${surveyTypeId}/employees`,
  successCallback,
  errorCallback,
  mountedRef,
});